import React from 'react';
import { cx } from '../cx';

// D-09 §15.32 — Start Card List
// (.start-card-list — 가로 카드 컨테이너, 내부 .start-card는 세로 구분선으로 분리)
export type StartCardListProps = React.HTMLAttributes<HTMLDivElement>;

export function StartCardList({ className = '', children, ...props }: StartCardListProps) {
  return (
    <div className={cx('start-card-list', className)} {...props}>
      {children}
    </div>
  );
}
